import { render } from "@/components/pages/dataRecollection/obdIumpr/obdIumprPage.html?vue&type=template&id=6d56892c&external"
import script from "@/components/pages/dataRecollection/obdIumpr/obdIumprPage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/obdIumpr/obdIumprPage.js?vue&type=script&lang=js&external"

import "@/components/pages/dataRecollection/obdIumpr/obdIumprPage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__